import React, { useState } from 'react'

import { Link } from 'react-router-dom';
import { Progress } from 'antd';





import { NuDate } from '../../../../../Components/Utils/Input';
import ToggleUp from '../../../../../Components/Icons/ToggleUp';
import ToggleDown from '../../../../../Components/Icons/ToggleDown';
import ViewMore from '../../../../Web/Project/SubMenu/Progress/Equipment/ViewMore';





function MobileEquipmentProData({taskData, getData, projectId,Unit}) {
    const [isTaskExpanded, setIsTaskExpanded] = useState(false);
    const [percentOpen, setPercentOpen] = useState(false);
  
    const handleToggle = () => {
      setIsTaskExpanded(!isTaskExpanded);
    };
    // console.log('====================================');
    // console.log(Type,"dddddd");
    // console.log('====================================');
  
    // function DateDiff(createDate, expiryDate) {
    //   createDate = new Date(createDate);
    //   expiryDate = new Date(expiryDate);
    //   let timeDiff = Math.abs(expiryDate.getTime() - createDate.getTime());
    //   let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    //   return diffDays == 0 ? diffDays + 1 : diffDays + 1;
    // }
  
    const userAccess = JSON.parse(localStorage.getItem("userAccess"));
    let MySubTaskCreate = userAccess
      ? userAccess.some(
          (permission) => permission.permissionName == "MySub_task_create"
        )
      : false;
  
  return (
    <div className=' m-[3px] bg-white rounded-md p-1' style={{border:'.5px solid gray'}}>
      <div className=' w-full flex px-1 bg-slate-100 items-center justify-between'>
        <div className=' w-[70%] px-2'>
        {/* <Link
            className="text-sm text-left font-normal text-mainColor-400 line-clamp-1"
            to={`/tasks/view/${taskData?.taskId}`}
            state={{projectId:projectId}}
          >
              {taskData?.designation||""}
          </Link> */}
        </div>
        <div className=' w-[10%]'>
        <div className=" w-full flex gap-2 justify-end px-3 cursor-pointer items-center">
           {/* <div className=" w-[13px] h-[13px] flex justify-center items-center">
           { <Link to="/tasks-plan/subtask/create" state={{ id: taskData?.taskId,projectId:projectId }}>
              <Plus color="#3267FF" />
            </Link>}
            </div>  */}
          </div>
        </div>
        <div className='w-full flex gap-1 justify-end px-1 items-center'>
       
        
                        
        </div>
      </div>
      <div className=' w-full flex  items-center text-xs justify-between'>
        <div className=''>
            <p className=' font-semibold   '>Description</p>
            {taskData?.description||"-"  }
        </div>
        <div className='ml-1'>
            <p className=' font-semibold '>Unit</p>
            {taskData?.unit || "-"}
        </div>
        <div className='ml-1'>
            <p className=' font-semibold'>Amount</p>
            {taskData?.amount || "-"}
        </div>
        <ViewMore data={taskData} id={taskData?.id} projectId={projectId} getData={getData} Unit={Unit}/>
        
      </div>
            
     
    </div>
  )
}

export default MobileEquipmentProData;